import React from "react";
import ProgressBar from "./ProgressBar";
import PickQuantityControls from "./PickQuantityControls";
import { PickProgressActions, PickProgressData } from "../OrderOverview/OrderOverview";

type Props = {
  isLoading: boolean;
  disabled: boolean;
  data: PickProgressData;
  actions: PickProgressActions;
};

const PickProgress = ({ isLoading, disabled, data, actions }: Props) => {
  const {
    pickedQuantity,
    adjustedPickedQuantity,
    confirmedQuantity,
    remainingQuantity,
    verifiedQuantity,
  } = data;

  const [isPickIncreased, isPickDecreased] = [
    adjustedPickedQuantity > pickedQuantity,
    adjustedPickedQuantity < pickedQuantity,
  ];

  const isPickQuantityVerified = verifiedQuantity >= pickedQuantity;

  const reviewStepCurrentQuantity = adjustedPickedQuantity;
  const reviewStepMaximumQuantity = isPickIncreased ? adjustedPickedQuantity : pickedQuantity;

  const verificationStepCurrentQuantity = verifiedQuantity;
  const verificationStepMaximumQuantity = pickedQuantity;

  const currentQuantity = isPickQuantityVerified
    ? reviewStepCurrentQuantity
    : verificationStepCurrentQuantity;

  const maximumQuantity = isPickQuantityVerified
    ? reviewStepMaximumQuantity
    : verificationStepMaximumQuantity;

  return (
    <>
      <ProgressBar
        isLoading={isLoading}
        data={data}
        currentQuantity={currentQuantity}
        totalQuantity={maximumQuantity}
        onSideAction={() =>
          actions.onAutoVerifyQuantity && actions.onAutoVerifyQuantity(data.itemId)
        }
      />
      <PickQuantityControls data={data} actions={actions} disabled={disabled} />
    </>
  );
};

export default PickProgress;
